import React from 'react';

const Radio = (widgetProps) => {
    let checkProps = {...widgetProps};
    delete checkProps.helperText;
    delete checkProps.error;
    delete checkProps.value;
    delete checkProps.onChange;


    return <div className="input-form">
        <label>{widgetProps.label} {widgetProps.required && !widgetProps.disabled ? '*' : ''}</label>
        <div className="form-group">  
             {widgetProps.options && Object.keys(widgetProps.options).map((option, index) => (
                <div class="radio">                   
                    <input 
                        type="radio" 
                        {...checkProps} 
                        value={option} 
                        checked={widgetProps.value === option || (widgetProps.value === null && index === 0) }
                        onChange={(e) => {
                            widgetProps.onChange({
                                target: {
                                    name: widgetProps.name,
                                    id: widgetProps.id,
                                    value: e.target.value
                                }
                            });
                        }} 
                    />
                    <label key={index} className="radio-option">
                        {widgetProps.options[option]}
                    </label>
                </div>
            ))}
        </div>
        {widgetProps.helperText && (
            <div className={`helper-text ${widgetProps.error ? 'error' : ''}`}>
            {widgetProps.helperText}
            </div>
        )}
    </div>
}
export default Radio;